import CheckListSvg from '@emojis/checklist.svg?react';
import GdprSvg from '@emojis/gdpr.svg?react';
import Login from '@emojis/login.svg?react';
import MonitorMode from '@emojis/monitor-mode.svg?react';
import Docaposte from '@emojis/personal_informations.svg?react';
import RatingSvg from '@emojis/rating.svg?react';
import RecommendationSvg from '@emojis/recommendations.svg?react';
import ResultsSvg from '@emojis/results.svg?react';
import propTypes from 'prop-types';

import * as style from './style.module.css';

const SplitLayout = ({ imageType = '', children, backgroundColor = 'secondary' }) => {
    return (
        <div className={style.container}>
            <div className={[style.sideBar, style[`${backgroundColor}Background`]].join(' ')}>
                <div className={style.imageContainer}>
                    {imageType === 'GDPR' && <GdprSvg />}
                    {imageType === 'RECOMMENDATION' && <RecommendationSvg />}
                    {imageType === 'END' && <ResultsSvg />}
                    {imageType === 'RATING' && <RatingSvg />}
                    {imageType === 'CHECKLIST' && <CheckListSvg />}
                    {imageType === 'MONITORMODE' && <MonitorMode />}
                    {imageType === 'DOCAPOSTE' && <Docaposte />}
                    {imageType === 'LOGIN' && <Login />}
                </div>
            </div>
            <div className={style.content}>
                {imageType === 'END' && (
                    <div className={style.endMobileContent}>
                        <ResultsSvg className={style.endImageMobile} />
                    </div>
                )}
                {children}
            </div>
        </div>
    );
};

SplitLayout.propTypes = {
    imageType: propTypes.oneOf(['GDPR', 'RECOMMENDATION', 'END', 'RATING', 'CHECKLIST', 'MONITORMODE', 'DOCAPOSTE']),
    children: propTypes.node,
};

export default SplitLayout;
